import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CustomDataSource, Sort } from '@app/classes';
import { License } from '@app/models';
import { IosDialogService, LicensesService } from '@app/services';
import { ConfirmAction, Header } from '@app/shared';
import { TranslateService } from '@ngx-translate/core';
import { LicenseDetailComponent } from '../license-detail/license-detail.component';

@Component({
  selector: 'app-licenses-list',
  templateUrl: './licenses-list.component.html',
  styleUrls: ['./licenses-list.component.scss'],
})
export class LicensesListComponent {
  @Input() dataSource: CustomDataSource<License>;
  @Output() onSort: EventEmitter<Sort[]> = new EventEmitter<Sort[]>();

  headers: Header[] = [
    { visibleName: 'LABELS.PRODUCT', name: 'module.name', sortable: true },
    { visibleName: 'LABELS.PRODUCT_TYPE', name: 'module.code', sortable: true },
    { visibleName: 'LABELS.LICENSE_TYPE', name: 'licenseType.code', sortable: true },
    { visibleName: 'LABELS.LICENSE_KEY' },
    { visibleName: 'LABELS.VALID_FROM', name: 'validFrom', sortable: true, default: true },
    { visibleName: 'LABELS.LICENSE_STATE', name: 'expired', sortable: false },
    { visibleName: 'LABELS.ACTIVATION_TYPE' },
  ];

  constructor(
    private dialog: IosDialogService,
    private translate: TranslateService,
    private licensesService: LicensesService,
  ) {}

  changeSort(res: Sort[]) {
    this.onSort.emit(res);
  }

  openLicenseDetail(license: License) {
    return this.dialog.openAndWaitResponse<ConfirmAction>(LicenseDetailComponent, {
      header: this.translate.instant('LABELS.LICENSE_DETAIL'),
      width: 'min(700px, 90vw)',
      data: {
        license,
      },
    });
  }
}
